import React from 'react';
import KorgM1Updater from './KorgM1Updater';

function App() {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <KorgM1Updater />
    </div>
  );
}

export default App;
